"use client";

import Image from "next/image";
import Link from "next/link";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { usePathname } from "next/navigation";

type SubMenuItem = {
  id: number;
  textItem: string;
  lienItem: string;
};

type MenuItem = {
  id: number;
  textMenu: string;
  lienMenu: string;
  sousMenu?: SubMenuItem[];
};

type LegalLinkItem = {
  id: number;
  textItem: string;
  lienItem: string;
};

type LogoType = {
  url: string;
  alternativeText?: string | null;
};

type FooterProps = {
  menu: MenuItem[];
  logo?: LogoType;
  legalLinks: LegalLinkItem[];
};

export default function Footer({ menu, logo, legalLinks }: FooterProps) {
  const [openMenus, setOpenMenus] = useState<number[]>([]);
  const pathname = usePathname();

  function toggleMenu(id: number) {
    setOpenMenus((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  }

  const pagesWithoutCommandeBlock = [
    "/concept",
    "/contact",
    "/repas-entreprise/chefs-d-entreprise-et-rh",
    "/repas-entreprise/reseaux-d-etablissements",
    "/repas-entreprise/salaries",
  ];

  const isAgencyPage =
    pathname.startsWith("/presentation-agence") ||
    pathname.startsWith("/livraison-repas-entreprise");

  const hasCommandeBlock =
    !pagesWithoutCommandeBlock.includes(pathname) && !isAgencyPage;

  return (
    <footer>
      <div
        className={`container rounded-t-3xl bg-violet-light py-16 mt-12 ${
          hasCommandeBlock ? "pt-30 lg:pt-36" : "pt-16"
        }`}
      >
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-start lg:gap-48 lg:pl-24">
          <div className="">
            <Link href="/" className="inline-block shrink-0">
              <Image
                src={logo?.url || ""}
                alt={logo?.alternativeText || "Régalice Pause Dej"}
                width={170}
                height={150}
              />
            </Link><div>
          
        </div>
          </div>
        
          <div className=" grid grid-cols-1 gap-8 text-left lg:grid-cols-2">
            {menu.map((item) => {
              const hasSubMenu = item.sousMenu && item.sousMenu.length > 0;
              const isOpen = openMenus.includes(item.id);

              return (
                <div key={item.id} className="flex flex-col gap-3">
                  {hasSubMenu ? (
                    <>
                      <button
                        type="button"
                        onClick={() => toggleMenu(item.id)}
                        className="flex items-center gap-2 text-left text-2xl font-medium text-black transition hover:text-pink"
                      >
                        <span>{item.textMenu}</span>
                        <ChevronDown
                          className={`h-5 w-5 transition-transform ${
                            isOpen ? "rotate-180" : ""
                          }`}
                        />
                      </button>

                      {isOpen && (
                        <div className="flex flex-col gap-2 pl-1">
                          {item.sousMenu?.map((subItem) => (
                            <Link
                              key={subItem.id}
                              href={subItem.lienItem}
                              className="text-lg font-normal text-black/75 transition hover:text-pink"
                            >
                              {subItem.textItem}
                            </Link>
                          ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <Link
                      href={item.lienMenu}
                      className="text-2xl font-medium text-black transition hover:text-pink"
                    >
                      {item.textMenu}
                    </Link>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className="pb-12 lg:px-20 lg:pb-0">
          <div className="mt-5 border-t border-black/70 pt-6">
            <div className="flex flex-wrap gap-x-8 gap-y-4 text-xl text-black">
              {legalLinks.map((item) => (
                <Link
                  key={item.id}
                  href={item.lienItem}
                  className="transition hover:text-pink"
                >
                  {item.textItem}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}